<template>
  <el-select
    filterable
    v-loading="requestLoading"
    :value="value"
    @input="inputtt"
    :placeholder="placeholder"
    clearable
    :multiple="multiple"
    @change="changeHanlder"
    :style="{
      width: width,
    }"
  >
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
      <span style="float: left">{{ item.name }}</span>
      <span
        :style="{ float: 'right', color: $jsTool.getColor('danger') }"
        v-if="item.frozen"
        >已冻结</span
      >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "QshpzyWebChannelSelect",
  props: {
    value: [Array, String],
    placeholder: {
      type: String,
      default: "请选择客户渠道",
    },
    width: {
      type: [Number, String],
      default: "180px",
    },
    frozenCanSelect: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      requestLoading: true,
      list: [],
    };
  },

  mounted() {
    this.flushList();
  },

  methods: {
    inputtt(e) {
      this.$emit("input", e || null);
    },
    changeHanlder(val) {
      this.$emit("change", val);
    },
    async flushList() {
      this.requestLoading = true;
      let requestRes = await this.$api.channel_findListForManage();
      if (requestRes && requestRes.success) {
        this.list = requestRes.data;
      }
      setTimeout(() => {
        this.requestLoading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ChannelSelect.vue